import $ from 'jquery';
import 'owl.carousel';

const carousel = () => {
  const slider = $('.c-columns-text__cols.owl-carousel');
  const $win = $(window);

  if (slider && slider.length) {
    const initOwl = () => {
      if ($win.width() < 960) {
        slider.owlCarousel({
          items: 1,
          center: true,
          stagePadding: 35,
          nav: false,
        });
      } else {
        slider.trigger('destroy.owl.carousel').removeClass('owl-loaded');
      }
    };

    initOwl();
    $(window).resize(() => {
      initOwl();
    });
  }

  const $carousel = $('.c-carousel.owl-carousel');
  if ($carousel && $carousel.length) {
    $carousel.owlCarousel({
      items: 1,
      dots: false,
      nav: true,
      autoHeight: true,
    });
  }
};
export default carousel;



// WEBPACK FOOTER //
// ./src/scripts/modules/carousel.js